<template>
  <div class="register" :style="{ height: windowHeight + 'px' }">
    <headerBar title="企业注册"></headerBar>

    <div class="form">
      <div class="form-input">
        <input type="text" placeholder="企业名称" v-model="store_name" />
        <img class="close" @click="store_name = ''" src="../../../static/images/close_02.png" alt />
      </div>
      <div class="form-input">
        <span style="color: #299E72;margin-right: 10px;">+86</span>
        <input type="text" placeholder="请输入手机号" v-model="mobile" />
        <img class="close" @click="mobile = ''" src="../../../static/images/close_02.png" alt />
      </div>
      <div class="form-input">
        <input type="text" placeholder="请输入验证码" v-model="checkcode" />
        <button :disabled="codeDisable" @click="getNumCode">{{ codetitle }}</button>
      </div>
      <div class="form-input">
        <input type="password" v-model="password" placeholder="登录密码" />
        <img class="close" @click="password = ''" src="../../../static/images/close_02.png" alt />
      </div>
      <div class="form-input">
        <input type="password" v-model="repassword" placeholder="确认密码" />
        <img class="close" @click="repassword = ''" src="../../../static/images/close_02.png" alt />
      </div>
      <div class="form-input">
        <input type="text" placeholder="推荐人ID或手机号(可为空)" v-model="p_id_or_mobile" />
        <img
          class="close"
          @click="p_id_or_mobile = ''"
          src="../../../static/images/close_02.png"
          alt
        />
      </div>
      <!--解决浏览器自动填充密码的问题-->
      <input type="password" autocomplete="new-password" hidden />
    </div>
    <p class="tips">注意：企业名称填写后不能修改，请认真填写</p>
    <div class="notice" @click="getXieYinotice">注册即视为同意《用户注册协议》</div>
    <div class="windows" v-if="xieyishow">
      <div class="mask" @click="xieyishow = false"></div>
      <div class="content xieyicontent">
        <div class="xietitle" v-html="doc_title"></div>
        <div class="heiGht" v-html="doc_content"></div>
      </div>
    </div>

    <button class="kuang" @click="submit" :disabled="btnState">
      <div class="bgmask"></div>
      <p>提交</p>
    </button>
    <div class="login" @click="login">去登录</div>
    <div class="help">
      <a href="https://yuan.znstny.cn/upload/caozuoshouce.doc">查看溯源中心操作手册</a>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      code: "", //注册成功返回的code码
      windowHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight,
      btnState: false,
      coupon_show: false, //多色米优惠券
      xieyishow: false,

      codeDisable: false, //验证码重复点击
      p_id_or_mobile: "", //推荐人id
      store_name: "", //企业名称
      mobile: "", //手机号
      password: "",
      repassword: "",
      checkcode: "", //验证码
      codetitle: "获取验证码",
      doc_title: "",
      doc_content: ""
    };
  },
  created() {},
  methods: {
    login() {
      this.$router.push({ path: "/login" });
    },
    getXieYinotice() {
      //获取协议
      // this.$request.post('/home/index/userRegister', {}, res => {
      //   if (res.status == 1) {
      //     this.xieyishow = true;
      //     this.doc_title = res.result.doc_title;
      //     this.doc_content = res.result.doc_content;
      //   } else {
      //     Toast(res.msg);
      //   }
      // });
    },
    //注册
    submit() {
      if (!this.store_name) {
        Toast("请填写您的姓名");
        return false;
      }
      if (!this.mobile) {
        Toast("请填写您的手机号");
        return false;
      }

      if (!this.checkcode) {
        Toast("请输入验证码");
        return false;
      }
      if (!this.password) {
        Toast("请输入密码");
        return false;
      } else {
        console.log(this.password.length);
        if (this.password.length < 6) {
          Toast("密码过短，不能小于6位数");
          return false;
        }
      }
      if (!this.repassword) {
        Toast("两次密码不一致");
        return false;
      }
      if (
        this.repassword &&
        this.password &&
        this.repassword != this.password
      ) {
        Toast("两次密码填写不一致请重新填写");
        return false;
      }
      this.btnState = true;

      this.$request.post(
        "/front/Login/frontreg",
        {
          store_name: this.store_name,
          mobile: this.mobile,
          password: this.password,
          repassword: this.repassword,
          checkcode: this.checkcode,
          p_id_or_mobile: this.p_id_or_mobile
          //is_app: 1
        },
        res => {
          if (res.status == 1) {
            window.localStorage.setItem("is_check_login", 1);
            window.localStorage.setItem("store_id", res.result.store_id);
            window.localStorage.setItem("token", res.result.token);
            //注册成功后需要验证商家状态。进行跳转；
            debugger;
            let url = "/front/Appsto/pstatus";
            this.$request.post(
              url,
              {
                // id: res.result.store_id,
                // token: res.result.token
              },
              res => {
                if (res.status == 1) {
                  //status -2 未完善信息  0 审核中 1审核通过 -1 审核失败
                  if (res.result.status == 1) {
                    this.$router.push("/projectList");
                  } else {
                    this.$router.push("/shopinformation");
                  }
                }
              }
            );
          }
          this.btnState = false;
          Toast(res.msg);
        }
      );
    },
    /**
     * 获取验证码
     * */
    getNumCode() {
      if (this.mobile) {
        let reg = /^[1][3-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$|^\d{10}$/;
        if (!reg.test(this.mobile)) {
          Toast("请输入正确的手机号");
        } else {
          //防重复点击
          if (this.codeDisable == false) {
            this.codeDisable = true;
            this.timeCount();

            let data = {
              mobile: this.mobile,
              type: 0 //type:0注册,type:1登录,type:2密码找回,type:3身份认证
            };
            let url = "/front/Sundries/send";
            this.$request.post(url, data, res => {});
          }
        }
      } else {
        Toast("请输入正确的手机号");
      }
    },
    /**
     * 验证码读秒
     */
    timeCount() {
      let num = 60;
      clearInterval(timer);
      let timer = setInterval(() => {
        num -= 1;
        this.codetitle = num + "s 重新获取";
        if (num < 0) {
          clearInterval(timer);
          this.codeDisable = false; //启用点击
          this.codetitle = "获取验证码";
        }
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.register {
  padding-top: 0.8rem;
  width: 100%;
  box-sizing: border-box;
  background: white;
  .tips {
    padding: 0 0.4rem;
    font-size: 0.26rem;
    color: #ff0000;
  }
}

.form {
  padding: 0.4rem;
}

.form-input {
  width: 100%;
  height: 1.1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #cccccc;
  position: relative;
  .close {
    position: absolute;
    right: 0.2rem;
    width: 0.4rem;
    height: 0.4rem;
  }
}
.form-input input {
  height: 1rem;
  width: 100%;
  height: 0.5rem;
  line-height: 0.5rem;
  font-size: 0.3rem;
}
.form-input button {
  width: 2rem;
  height: 0.6rem;
  line-height: 0.6rem;
  border-radius: 0.3rem;
  border: 1px solid #00b378;
  font-size: 0.26rem;
  color: #00b378;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 0.2rem;
}

.register-btn {
  margin: 0.2rem 0 0.2rem;
  width: 100%;
  height: 0.8rem;
  background: #00b378;
  color: white;
  border-radius: 0.4rem;
  font-size: 0.32rem;
}

.yaoqingid {
  width: 5rem;
}

.notice {
  margin-top: 1rem;
  width: 100%;
  text-align: center;
}

.windows .content {
  width: 6.8rem;
  position: fixed;
  top: 50%;
  left: 50%;
  height: 80%;
  transform: translate(-50%, -50%);
  background: white;
  z-index: 1001;
  border-radius: 0.1rem;
  padding: 0.4rem;
  box-sizing: border-box;
  overflow-y: scroll;
}

.windows .content .title {
  color: #333333;
  font-size: 0.32rem;
  text-align: center;
  margin: 0.4rem 0 0.5rem;
}

.windows .content .notice {
  text-align: center;
  font-size: 0.28rem;
  color: #666666;
  margin-bottom: 0.5rem;
}

.windows .content .opt {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.3rem;
}

.windows .content .opt button {
  width: 1.8rem;
  height: 0.6rem;
  text-align: center;
  line-height: 0.6rem;
  font-size: 0.3rem;
  border: none;
  background: none;
  border-radius: 0.3rem;
  margin: 0 0.2rem;
}

.windows .content .opt .cancel {
  background: #cccccc;
  color: #333333;
}

.windows .content .opt .confrim {
  background: #354177;
  color: white;
}

.windows .content .opt a {
  text-decoration: none;
  color: white;
}

.xietitle {
  text-align: center;
  font-size: 0.34rem;
  font-weight: 600;
  line-height: 1rem;
}

.heiGht {
  line-height: 0.5rem;
  color: #666666;
}

.kuang {
  border-color: #299e72;
  padding: 0;
  margin-top: 0.4rem;
  .bgmask {
    background: #299e72;
  }
  p {
    color: #299e72;
    font-size: 0.38rem;
  }
}

.login {
  width: 5rem;
  height: 0.8rem;
  line-height: 0.8rem;
  margin: 0rem auto 0.6rem;
  border-radius: 5px;
  overflow: hidden;
  text-align: center;
  background: #10865f;
  color: #ffffff;
}
.help {
  text-align: center;
  margin-top: 0.3rem;
  width: 5rem;
  height: 0.8rem;
  line-height: 0.8rem;
  margin: 0rem auto 0.6rem;
  border-radius: 5px;
  overflow: hidden;
  text-align: center;
  background: #cf6006;

  a {
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login/register.vue